/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as TYPES from './types';
import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const setNDCErrorPopupMessage = (payload) => {
  return {
    type: TYPES.NDC_ERROR_POPUP_MESSAGE,
    payload,
  };
};

export const setNDCSuccessMessage = (payload) => {
  return {
    type: TYPES.NDC_SUCCESS_MESSAGE,
    payload,
  };
};

export const setNDCSelectedNDCTab = (payload) => {
  return {
    type: TYPES.NDC_SELECTED_NDC_TAB,
    payload,
  };
};

export const setSearchByDrugNameTableData = (payload) => {
  return {
    type: TYPES.NDC_SEARCH_BY_DRUG_NAME_TABLE_DATA,
    payload,
  };
};

export const setSearchByDrugName = (payload) => {
  return {
    type: TYPES.SET_NDC_SEARCH_BY_DRUG_NAME,
    payload,
  };
};

export const setLabelerDrugTableData = (payload) => {
  return {
    type: TYPES.NDC_LABELER_DRUG_TABLE_DATA,
    payload,
  };
};

export const setLabelerTableData = (payload) => {
  return {
    type: TYPES.NDC_LABELER_TABLE_DATA,
    payload,
  };
};

export const setNDCDetailsTableData = (payload) => {
  return {
    type: TYPES.NDC_DETAILS_TABLE_DATA,
    payload,
  };
};

export const setNDCDetailsTableRowSelected = (payload) => {
  return {
    type: TYPES.NDC_DETAILS_TABLE_ROW_SELECTED,
    payload,
  };
};

export const setNDCDetails = (payload) => {
  return {
    type: TYPES.NDC_DETAILS,
    payload,
  };
};

export const setNDCDetailsTabSelected = (payload) => {
  return {
    type: TYPES.NDC_DETAILS_TAB_SELECTED,
    payload,
  };
};

export const setCurrentNDCDetailsSelected = (payload, dataType) => {
  return {
    type: TYPES.CURRENT_NDC_DETAILS_SELECTED,
    payload,
    dataType: dataType,
  };
};

export const setCurrentNDCDetailsIndex = (payload) => {
  return {
    type: TYPES.CURRENT_NDC_DETAILS_INDEX,
    payload,
  };
};

export const setNDCReferenceData = (payload) => {
  return {
    type: TYPES.NDC_REFERENCE_DATA,
    payload,
  };
};

export const dispatchGetGeneralSystemParametersResultDetails = (payload) => {
  return {
    type: TYPES.NDC_GENERAL_PARAMETERS,
    payload,
  };
};

export const setPriceTypeDetails = (payload) => {
  return {
    type: TYPES.PRICE_TYPE_DETAILS,
    payload,
  };
};

export const setNDCLoading = (payload) => {
  return {
    type: TYPES.NDC_LOADING,
    payload,
  };
};

export const resetNDCData = () => {
  return {
    type: TYPES.RESET_NDC_DATA,
  };
};

export const resetNDCDetailsData = () => {
  return {
    type: TYPES.RESET_NDC_DETAILS_DATA,
  };
};

export const setSearchByNDCIDTwo = (payload) => {
  return {
    type: TYPES.SEARCH_BY_NDC_ID,
    payload,
  };
};

export const checkNDCAndAddToDetailsTable = (data) => {
  return (dispatch, getState) => {
    dispatch(setNDCLoading(true));
    const currentDetailsTableData = [
      ...getState().sharedState.ndc.ndcDetailsTableData,
    ];
    const userId =
      getState().sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.userId ||
      getState().sharedState?.SharedReducer?.logInUser?.toUpperCase();
    if (data.length === 1) {
      const index = currentDetailsTableData.findIndex(
        (item) => item.ndc === data[0].ndc
      );

      if (index === -1) {
        currentDetailsTableData.push({
          ndc: data[0].ndc,
          drugName: data[0].drugName,
          drugSeqNum: data[0].drugSeqNum,
          userID: userId,
          //userLastName: 'TEST',
          functionCode: 'NDC',
          eventInquryKeyVO: [
            {
              keyType: 'NDC',
              key: data[0].ndc,
            },
          ],
        });

        dispatch(setNDCDetailsTableData(currentDetailsTableData));
      } else {
        dispatch(setNDCErrorPopupMessage('NDC already added'));
      }
    } else {
      data.forEach((ndcItem) => {
        const index = currentDetailsTableData.findIndex(
          (item) => item.ndc === ndcItem.ndc
        );

        if (index === -1) {
          currentDetailsTableData.push({
            ndc: ndcItem.ndc,
            drugName: ndcItem.drugName,
            drugSeqNum: ndcItem.drugSeqNum,
            userID: userId,
            //userLastName: 'TEST',
            functionCode: 'NDC',
            eventInquryKeyVO: [
              {
                keyType: 'NDC',
                key: ndcItem.ndc,
              },
            ],
          });
        }
      });
      dispatch(setNDCDetailsTableData(currentDetailsTableData));
    }
    dispatch(setNDCLoading(false));
  };
};

export const removeFromNDCDetailsTableData = (removeAll = false) => {
  return (dispatch, getState) => {
    const currentDetailsTableData = [
      ...getState().sharedState.ndc.ndcDetailsTableData,
    ];
    const currentDetailsTableSelectedRow = [
      ...getState().sharedState.ndc.ndcDetailsTableRowSelected,
    ];

    if (currentDetailsTableData.length === 0) {
      dispatch(setNDCErrorPopupMessage('Nothing to remove.'));
    } else if (removeAll) {
      dispatch(setNDCErrorPopupMessage(null));
      dispatch(setNDCDetailsTableRowSelected([]));
      dispatch(setNDCDetailsTableData([]));
    } else if (currentDetailsTableSelectedRow.length === 0) {
      dispatch(
        setNDCErrorPopupMessage(
          'Please select a drug to remove from the selected list.'
        )
      );
    } else {
      let updatedCurrentDetailsTableData = currentDetailsTableData.filter(
        (filterItem) =>
          currentDetailsTableSelectedRow.findIndex(
            (item) => item.ndc === filterItem.ndc
          ) === -1
      );
      dispatch(setNDCErrorPopupMessage(null));
      dispatch(setNDCDetailsTableRowSelected([]));
      dispatch(setNDCDetailsTableData(updatedCurrentDetailsTableData));
    }
  };
};

export const naviagteToNDCDetailsPageAction = ({
  ndcDetailsTableData,
  succesFunc = () => {},
  errorFunc = () => {},
}) => {
  return async (dispatch) => {
    const response = await getNDCDetails([ndcDetailsTableData[0]]);

    if (response) {
      dispatch(setNDCErrorPopupMessage(null));
      dispatch(setCurrentNDCDetailsIndex(1));
      dispatch(setCurrentNDCDetailsSelected(response[0], 'All'));
      dispatch(setNDCDetails(ndcDetailsTableData));
      succesFunc();
    } else {
      errorFunc();
    }
  };
};

// API Call

export const searchNDCByIDORDrugName = async (values) => {
  try {
    const response = await axios.post(
      serviceEndPoint.SEARCH_NDC_BY_ID_OR_DRUG_NAME,
      values
    );

    if (response.data && response.data.data && response.data.data.length > 0) {
      return response.data.data.map((item) => {
        return {
          ...item,
          ndc: `${item.labelerCode}-${item.productCode}-${item.packageSize}`,
        };
      });
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
};

export const getDrugListForLabeler = async (values) => {
  try {
    const response = await axios.post(
      serviceEndPoint.LIST_DRUG_FOR_LABELERS,
      values
    );

    if (response.data && response.data.data && response.data.data.length > 0) {
      return response.data.data.map((item) => {
        return {
          ...item,
          ndc: `${item.labelerCode}-${item.productCode}-${item.packageSize}`,
        };
      });
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
};

export const getAllLabelerList = async () => {
  try {
    const response = await axios.get(serviceEndPoint.NDC_LABELERS_LIST);

    if (response.data && response.data.data && response.data.data.length > 0) {
      return response.data.data;
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
};

export const getNDCDetails = async (values) => {
  try {
    const response = await axios.post(serviceEndPoint.NDC_DETAILS, values);

    if (response.data && response.data.data && response.data.data.length > 0) {
      return response.data.data;
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
};

export const getAllNDCReferenceData = () => {
  return async (dispatch) => {
    try {
      const response = await axios.post(serviceEndPoint.NDC_REFERENCE_DATA, {
        codeDomainList: [
          'DRUG_CAT_CD',
          'DRUG_TYPE_CD',
          'UNIT_TYPE_CD',
          'URA_TYPE_CD',
          'DRUG_ROUTE_CD',
          'DRAMS_UNIT_TYPE_CD',
          'SPEC_THERA_CLASS_CD',
        ],
      });

      if (response.data) {
        dispatch(setNDCReferenceData(response.data));
      } else {
        dispatch(setNDCReferenceData(null));
      }
    } catch (e) {
      dispatch(setNDCReferenceData(null));
    }
  };
};

export const getPriceTypeDetails = () => (dispatch) => {
  return axios
    .get(serviceEndPoint.GET_PRICETYPE_DATA)
    .then((response) => {
      if (
        response.data &&
        response.data.data &&
        response.data.data.length > 0
      ) {
        dispatch(setPriceTypeDetails(response.data.data));
      } else {
        dispatch(setPriceTypeDetails([]));
      }
    })
    .catch((error) => {
      dispatch(setPriceTypeDetails([]));
    });
};

export const updateNDCDetails = (values, index) => {
  return async (dispatch, getState) => {
    const currentNDCDetailsSelected = {
      ...getState().sharedState.ndc.currentNDCDetailsSelected,
    };

    try {
      await axios.post(serviceEndPoint.UPDATE_NDC_DETAILS, values);

      const response = await getNDCDetails([
        {
          ndc: `${currentNDCDetailsSelected.labelerCode}-${currentNDCDetailsSelected.productCode}-${currentNDCDetailsSelected.packageSize}`,
          drugName: currentNDCDetailsSelected.drugName,
        },
      ]);

      if (response && response.length > 0) {
        dispatch(setCurrentNDCDetailsSelected(response[0], 'All'));
      } else {
        currentNDCDetailsSelected.cmsDrugVOs[index] = { ...values };
        dispatch(
          setCurrentNDCDetailsSelected(currentNDCDetailsSelected, 'All')
        );
      }

      dispatch(setNDCSuccessMessage('CMS DRUG data updated successfully.'));
    } catch (e) {
      dispatch(setNDCErrorPopupMessage('Something went wrong'));
    }
  };
};

export const getGeneralsystemparameterDetails = (values) => (dispatch) => {
  return axios
    .get(serviceEndPoint.GET_GENERAL_SYSTEM_PARAMETER, values)
    .then((response) => {
      dispatch(
        dispatchGetGeneralSystemParametersResultDetails(
          response.data && response.data.data
        )
      );
    })
    .catch((error) => {
      dispatch(dispatchGetGeneralSystemParametersResultDetails([]));
    });
};

export const getExistingCorrLinkIds = (value) => {
  return axios
    .post(serviceEndPoint.GET_EXISTING_COMMENT_LINK_IDS, value)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};
